import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";
import LoadingSpinner from "../components/LoadingSpinner";
import InfiniteScroll from "../components/InfiniteScroll";
import { useInfiniteScroll } from "../hooks/useInfiniteScroll";

const PAGE_SIZE = 8;

const Sellers = () => {
  const fetchSellers = useCallback(async (page) => {
    const params = new URLSearchParams();
    params.append("type", "S");
    params.append("page", page);
    params.append("page_size", String(PAGE_SIZE));
    return apiClient.get(`/register/?${params.toString()}`);
  }, []);

  const { data: sellers, loading, hasMore, loadMore } = useInfiniteScroll(
    fetchSellers,
    [],
    PAGE_SIZE,
  );

  const showInitialSpinner = loading && sellers.length === 0;

  return (
    <div className="px-2">
      <h2 className="mb-3" style={{ color: "#000000e6" }}>
        Sellers
      </h2>
      {showInitialSpinner ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingSpinner color="#FF3E1F" />
        </div>
      ) : sellers.length === 0 ? (
        <p className="text-muted">No sellers found.</p>
      ) : (
        <InfiniteScroll
          onLoadMore={loadMore}
          hasMore={hasMore}
          loading={loading}
          loader={<LoadingSpinner color="#FF3E1F" />}
        >
          <ul className="p-0">
            {sellers.map((seller) => (
              <li
                key={seller.id}
                className="d-flex gap-md-5 gap-3 flex-wrap flex-md-nowrap shadow align-items-center p-4 rounded-3 mb-3"
                style={{ backgroundColor: "#fff" }}
              >
                <div style={{ width: "30%" }}>
                  <h5 className="fw-bold ">Seller Name</h5>
                  <p className="mb-0">{seller.full_name}</p>
                </div>
                <div style={{ width: "30%" }}>
                  <h5 className="fw-bold ">Email</h5>
                  <p className="mb-0">{seller.email}</p>
                </div>
                <Link
                  to={`/admin/user-detail/?id=${seller?.id}`}
                  state={{ from: "/admin/sellers" }}
                  className="btn grey-btn rounded-3 ms-auto "
                >
                  Show More
                </Link>
              </li>
            ))}
          </ul>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default Sellers;
